export default __webpack_public_path__ + "static/media/03-mukbang.02af7963.jpg";